
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="footer 汇总自定义单元格" fileName="custom-cell.md" />
        <demo-block>
        <div><p>1、column 配置中，支持通过属性 <code>renderFooterCell</code> 传入渲染函数，与 body 自定义单元格用法一致。<br>2、渲染函数接收三个参数，row:当前行数据、column:当前列配置、rowIndex:行索引</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-table
        border-y
        fixed-header
        :max-height=&quot;300&quot;
        :columns=&quot;columns&quot;
        :table-data=&quot;tableData&quot;
        :footer-data=&quot;footerData&quot;
        rowKeyFieldName=&quot;rowKey&quot;
    /&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                columns: [
                    {
                        field: &quot;name&quot;,
                        key: &quot;a&quot;,
                        title: &quot;Name&quot;,
                        align: &quot;center&quot;,
                        renderFooterCell: ({ row, column, rowIndex }, h) =&gt; {
                            return (
                                &lt;span class=&quot;text-bold&quot; style=&quot;&quot;&gt;
                                    {row.name}
                                &lt;/span&gt;
                            );
                        },
                    },
                    { field: &quot;date&quot;, key: &quot;b&quot;, title: &quot;Date&quot;, align: &quot;left&quot; },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        align: &quot;center&quot;,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Address&quot;,
                        align: &quot;left&quot;,
                    },
                ],
                tableData: [],
                footerData: [],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i &lt; 15; i++) {
                    data.push({
                        rowKey: i,
                        name: i,
                        date: i,
                        hobby: i,
                        address: i,
                    });
                }
                this.tableData = data;
            },

            initFooterData() {
                this.footerData = [
                    {
                        rowKey: 0,
                        name: &quot;平均值&quot;,
                        date: 213,
                        hobby: 355,
                        address: 189,
                    },
                    {
                        rowKey: 1,
                        name: &quot;汇总值&quot;,
                        date: 1780,
                        hobby: 890,
                        address: 2988,
                    },
                ];
            },
        },
        created() {
            this.initTableData();
            this.initFooterData();
        },
    };
&lt;/script&gt;

&lt;style&gt;
    .text-bold {
        font-weight: bold;
    }
&lt;/style&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-table',{attrs:{"border-y":"","fixed-header":"","max-height":300,"columns":_vm.columns,"table-data":_vm.tableData,"footer-data":_vm.footerData,"rowKeyFieldName":"rowKey"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                columns: [
                    {
                        field: "name",
                        key: "a",
                        title: "Name",
                        align: "center",
                        renderFooterCell: ({ row, column, rowIndex }, h) => {
                            return (
                                <span class="text-bold" style="">
                                    {row.name}
                                </span>
                            );
                        },
                    },
                    { field: "date", key: "b", title: "Date", align: "left" },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        align: "center",
                    },
                    {
                        field: "address",
                        key: "d",
                        title: "Address",
                        align: "left",
                    },
                ],
                tableData: [],
                footerData: [],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i < 15; i++) {
                    data.push({
                        rowKey: i,
                        name: i,
                        date: i,
                        hobby: i,
                        address: i,
                    });
                }
                this.tableData = data;
            },

            initFooterData() {
                this.footerData = [
                    {
                        rowKey: 0,
                        name: "平均值",
                        date: 213,
                        hobby: 355,
                        address: 189,
                    },
                    {
                        rowKey: 1,
                        name: "汇总值",
                        date: 1780,
                        hobby: 890,
                        address: 2988,
                    },
                ];
            },
        },
        created() {
            this.initTableData();
            this.initFooterData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      .text-bold {
        font-weight: bold;
    }
    </style>
  